import { render, staticRenderFns } from "./TotalLogTable.vue?vue&type=template&id=2251b8a2&scoped=true"
import script from "./TotalLogTable.vue?vue&type=script&lang=js"
export * from "./TotalLogTable.vue?vue&type=script&lang=js"
import style0 from "./TotalLogTable.vue?vue&type=style&index=0&id=2251b8a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2251b8a2",
  null
  
)

export default component.exports